import pages from '@/config/i18n.pages'
import SEO from '@/services/seo'

const defaultOptions = {
  url: '',
  title: '',
  description: '',
  general: {
    image: `${process.env.BASE_URL}/static/app-hotmart-jobs/images/share--general.png`,
  },
  facebook: {
    image: `${process.env.BASE_URL}/static/app-hotmart-jobs/images/share--facebook.png`,
  },
  twitter: {
    image: `${process.env.BASE_URL}/static/app-hotmart-jobs/images/share--twitter.png`,
  },
}

export const setAlternate = (payload) => {
  const { routeName, param, data } = payload
  const baseUrl = process.env.BASE_URL
  const alternate = []
  let page
  const positions = param && data.positions ? data.positions : false
  const firstString = routeName.split('___')[0]
  const locale = routeName.split('___')[1]

  if (
    firstString == 'index' ||
    firstString == 'culture' ||
    firstString == 'programs'
  ) {
    page = firstString
  }
  if (firstString == 'positions') {
    page = `${firstString}/index`
  }
  if (firstString == 'positions-id') {
    page = `positions/_id`
  }

  const prefix = () => {
    let local

    if (param && data.positions) {
      local = positions.en.length > 0 ? 'en' : false
      !local && positions['pt-br'].length > 0 ? (local = 'pt-br') : false
    } else {
      pages[`${page}`].en ? (local = 'en') : (local = 'pt-br')
    }
    const defaultUrl = `${local}${pages[`${page}`][local]}`

    const url = defaultUrl.replace('/:slug', '').replace('/:id', '')

    return url
  }

  const defaultParam = () => {
    const result =
      param && data.positions
        ? param
        : pages[`${page}`].en
        ? data.areas.en
        : data.areas['pt-br']

    return result
  }

  const alternateDefault = {
    hid: 'alt-default',
    rel: 'alternate',
    href: `${baseUrl}/${prefix()}${param ? `/${defaultParam()}` : ''}`,
    hreflang: 'x-default',
  }

  const pagesVariants = Object.keys(pages[`${page}`])

  pagesVariants.map((variant) => {
    if (variant) {
      const hreflang =
        variant.length > 2
          ? `${variant.split('-')[0]}-${variant.split('-')[1].toUpperCase()}`
          : variant
      let href
      href = pages[`${page}`][`${variant}`]
        .replace('/:slug', '')
        .replace('/:id', '')

      if (param) {
        href = `${href}/${data.areas ? data.areas[variant] : param}`
      }

      const alternateObj = {
        hid: `alt-${variant}`,
        rel: 'alternate',
        href: `${baseUrl}/${variant}${href}`,
        hreflang,
      }

      if (param && data.positions) {
        if (positions[variant].length > 0) alternate.push(alternateObj)
      } else {
        alternate.push(alternateObj)
      }
    }

    return true
  })

  if (param && data.positions) {
    let exist

    exist = positions.en.length > 0
    !exist && positions['pt-br'].length > 0 ? (exist = true) : null

    if (exist) alternate.push(alternateDefault)
  } else {
    alternate.push(alternateDefault)
  }

  return alternate
}

const addDynamicScripts = (langs, paths, scripts, baseOptions) => {
  if (langs.includes(baseOptions.lang)) {
    const pathname = baseOptions.url.split('/').slice(4).join('/')
    if (paths.includes(pathname)) return scripts
  }

  return []
}

export const head = (customOptions) => {
  const defaultScripts = [
    {
      src: 'https://static.hotmart.com/hot-lgpd/lgdpscript.min.js',
      defer: true,
      body: true,
    },
    {
      type: 'application/ld+json',
      json: customOptions.breadcrumbs,
      body: true,
    },
  ]

  const schemaWebsite = {
    type: 'application/ld+json',
    json: SEO.schema.website.getSchemaObj(),
    body: true,
  }

  defaultScripts.push(schemaWebsite)

  const options = Object.assign({}, defaultOptions, customOptions)
  const title = options.title ? options.title : defaultOptions.title
  const description = options.description
    ? options.description
    : defaultOptions.description
  const script = customOptions.script
    ? [...defaultScripts, ...customOptions.script]
    : defaultScripts
  const htmlAttrs = customOptions.htmlAttrs
  const link = customOptions.link
  const generalImage = options.image
    ? options.image
    : defaultOptions.general.image
  const facebookImage = options.facebook
    ? options.facebook.image
    : defaultOptions.facebook.image
  const twitterImage = options.twitter
    ? options.twitter.image
    : defaultOptions.twitter.image

  const dynamicScript = addDynamicScripts(
    ['pt-br'],
    [
      'trabalhe-conosco',
      'trabalhe-conosco/areas/ciencia-de-dados',
      'trabalhe-conosco/areas/desenvolvimento',
      'trabalhe-conosco/areas/ti-infraestrutura-e-seguranca',
      'trabalhe-conosco/areas/produtos',
    ],
    [],
    options
  )

  const head = {
    htmlAttrs: { ...htmlAttrs },
    title,
    meta: [
      // Share - General
      { hid: 'url', itemprop: 'url', content: options.url },
      { hid: 'description', name: 'description', content: description },
      { hid: 'image', itemprop: 'image', content: generalImage },

      // Share - Facebook
      { hid: 'og:type', property: 'og:type', content: 'website' },
      { hid: 'og:title', property: 'og:title', content: options.title },
      {
        hid: 'og:description',
        property: 'og:description',
        content: description,
      },
      { hid: 'og:image', property: 'og:image', content: facebookImage },
      { hid: 'og:site_name', property: 'og:site_name', content: options.title },
      { hid: 'og:locale', property: 'og:locale', content: options.lang },
      { hid: 'og:url', property: 'og:url', content: options.url },

      // Share - Twitter
      { hid: 'twitter:card', name: 'twitter:card', content: 'summary' },
      { hid: 'twitter:site', name: 'twitter:site', content: '@hotmart' },
      { hid: 'twitter:creator', name: 'twitter:creator', content: '@hotmart' },
      { hid: 'twitter:url', name: 'twitter:url', content: options.url },
      { hid: 'twitter:title', name: 'twitter:title', content: options.title },
      {
        hid: 'twitter:description',
        name: 'twitter:description',
        content: description,
      },
      { hid: 'twitter:image', name: 'twitter:image', content: twitterImage },
    ],
    script: [...script, ...dynamicScript],
    link: [...link, { rel: 'canonical', href: options.canonical }],
  }

  return head
}

export default {
  head,
}
